import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonopolyTurnGameSelectorComponent } from './monopoly-turn-game-selector/monopoly-turn-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MonopolyTurnGameCoreService } from './monopoly-turn-game-core.service';

@NgModule({
  declarations: [MonopolyTurnGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [MonopolyTurnGameCoreService],
  exports: [MonopolyTurnGameSelectorComponent],
})
export class MonopolyTurnGameCoreModule {}
